import React from 'react'
import {AUTH_PREFIX_PATH, APP_PREFIX_PATH} from 'configs/AppConfig'
import {roles} from "./routes/roles";
import {correspondants} from "./routes/correspondants";
import {sections} from "./routes/sections";
import {fonctions} from "./routes/fonctions";
import {personnels} from "./routes/personnels";
import {uas} from "./routes/uas";
import {courriers} from "./routes/courriers";
import {organigrammes} from "./routes/organigrammes";
import {archivage} from "./routes/archivage";
import { processingTimes } from './routes/processingTimes';
import { processes } from './routes/processes';
import { contrats } from './routes/contrats';
import { holidays } from './routes/holidays';
import { importAcPrmp } from './routes/importAcPrmp';
import { avisConfigs } from './routes/avisConfig';

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
]

export const protectedRoutes = [
    {
        key: 'dashboard',
        path: `${APP_PREFIX_PATH}`,
        component: React.lazy(() => import('views/app-views')),
    },

    {
        key: 'acteurs',
        path: `${APP_PREFIX_PATH}/acteurs`,
        component: React.lazy(() => import('views/app-views/acteurs')),
    },

    {
        key: 'profile',
        path: `${APP_PREFIX_PATH}/profile`,
        component: React.lazy(() => import('views/app-views/profile')),
    },

    {
        key: 'notifications',
        path: `${APP_PREFIX_PATH}/notifications`,
        component: React.lazy(() => import('views/app-views/profile/notifications')),
    },

    {
        key: 'stats_dossiers',
        path: `${APP_PREFIX_PATH}/stats/dossiers`,
        component: React.lazy(() => import('views/app-views/statistiques/dossiers')),
        meta: {
            permission: "STATS_DOSSIERS"
        }
    },


    ...archivage,
    ...contrats,
    ...courriers,
    ...uas,
    ...personnels,
    ...fonctions,
    ...sections,
    ...correspondants,
    ...organigrammes,
    ...roles,
    ...processingTimes,
    ...processes,
    ...holidays,
    ...importAcPrmp,
    ...avisConfigs,

    {
        key: "list_types",
        path: `${APP_PREFIX_PATH}/types`,
        component: React.lazy(() => import("views/app-views/types")),
        meta: {permission: 'LIST_TYPES'}
    },

    {
        key: "list_types",
        path: `${APP_PREFIX_PATH}/types-non-valide`,
        component: React.lazy(() => import("views/app-views/typesNonValide")),
        meta: {permission: 'LIST_TYPES'}
    },

    {
        key: 'users',
        path: `${APP_PREFIX_PATH}/users`,
        component: React.lazy(() => import('views/app-views/user')),
    },
]